import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Index from '@/components/Index'
import Login from '@/components/Login'
import HotelList from '@/components/hotel/List' //酒店列表
import HotelTemp from '@/components/hotel/hotelTemp' //酒店详情中转页
import HotelDetails from '@/components/hotel/Details' //酒店详情
import HotelBook from '@/components/hotel/book' //订单填写
import BookComfirm from '@/components/hotel/bookComfirm' //酒店下单
import BookComplete from '@/components/hotel/bookComplete' //酒店下单完成
import OrderList from '@/components/order/List' //订单查询
import OrderDetails from '@/components/order/Details' //订单详情
import OrderCustomer from '@/components/order/Customer' //入住人订单
import BillList from '@/components/bill/List' //账单查询
import BillDetails from '@/components/bill/Details' //账单详情
import ReportDay from '@/components/report/ReportDay' //日报表
import ReportList from '@/components/report/List' //报表列表
import ReportMonth from '@/components/report/ReportMonth' //月报表
import Invoice from '@/components/invoice/invoice' //发票
import Information from '@/components/invoice/information' //发票信息
import InvoiceDetails from '@/components/invoice/details' //发票详情
import Hotel from '@/components/invoice/hotel' //酒店发票
import BaseInfo from '@/components/account/BaseInfo' //基础信息
import ReceiptsBill from '@/components/bill/ReceiptsBill' //信贷详情
import ReceiptsBillNew from '@/components/bill/ReceiptsBillNew' //信贷详情新
import ChargeBill from '@/components/bill/ChargeBill' //充值详情
import ResetPassword from '@/components/account/ResetPassword' //修改密码







Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            name: 'Index',
            component: Index,
            meta: {
                keepAlive: true,
                parentMenu: 'Index'
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                isHome: true
            }
        },

        //酒店详情中转页
        {
            path: '/hotelTemp',
            name: 'hotelTemp',
            component: HotelTemp,
            meta: {
                parentMenu: 'Index'
            }
        },
        //酒店列表
        {
            path: '/hotelList',
            name: 'HotelList',
            component: HotelList,
            meta: {
                parentMenu: 'auto'
            }
        },
        //酒店详情
        {
            path: '/hotelDetails',
            name: 'HotelDetails',
            component: HotelDetails,
            meta: {
                parentMenu: 'Index'
            }
        },
        //订单填写
        {
            path: '/hotelBook',
            name: 'HotelBook',
            component: HotelBook,
            meta: {
                parentMenu: 'Index'
            }
        },
        //酒店下单
        {
            path: '/bookComfirm',
            name: 'BookComfirm',
            component: BookComfirm,
            meta: {
                parentMenu: 'Index'
            }
        },
        //酒店下单完成
        {
            path: '/bookComplete',
            name: 'BookComplete',
            component: BookComplete,
            meta: {
                parentMenu: 'Index'
            }
        },
        //订单查询
        {
            path: '/orderList',
            name: 'OrderList',
            meta: {
                parentMenu: 'OrderList'
            },
            component: OrderList
        },

        //订单详情
        {
            path: '/orderDetails/:orderNO',
            name: 'OrderDetails',
            component: OrderDetails,
            meta: {
                isHome: true
            }
        },
        //客人入住
        {
            path: '/orderCustomer/:orderNO',
            name: 'OrderCustomer',
            component: OrderCustomer,
            meta: {
                isHome: true
            }
        },
        //账单查询
        {
            path: '/billList',
            name: 'BillList',
            meta: {
                parentMenu: 'OrderList'
            },
            component: BillList
        },
        //账单详情
        {
            path: '/billDetails/:id',
            name: 'BillDetails',
            component: BillDetails,
            meta: {
                isHome: true
            }
        },

        //基础信息
        {
            path: '/baseInfo',
            name: 'BaseInfo',
            meta: {
                parentMenu: 'OrderList'
            },
            component: BaseInfo
        },
        //信贷信息
        {
            path: '/receiptsBill',
            name: 'ReceiptsBill',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReceiptsBill
        },
        //信贷信息新
        {
            path: '/receiptsBillNew',
            name: 'ReceiptsBillNew',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReceiptsBillNew
        },
        //充值信息
        {
            path: '/chargeBill',
            name: 'ChargeBill',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ChargeBill
        },
        //修改密码
        {
            path: '/resetPassword',
            name: 'ResetPassword',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ResetPassword
        },
        //日看板
        {
            path: '/reportDay',
            name: 'ReportDay',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReportDay
        },
        //月看板
        {
            path: '/reportMonth',
            name: 'ReportMonth',
            meta: {
                parentMenu: 'OrderList'
            },
            component: ReportMonth
        },
        //交易报表
        {
            path: '/reportList',
            name: 'ReportList',
            component: ReportList,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //发票
        {
            path: '/invoice',
            name: 'Invoice',
            component: Invoice,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //发票信息
        {
            path: '/information',
            name: 'Information',
            component: Information,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //发票详情
        {
            path: '/invoiceDetails/:orderNO',
            name: 'InvoiceDetails',
            component: InvoiceDetails,
            meta: {
                parentMenu: 'OrderList'
            },
        },
        //酒店发票
        {
            path: '/hotel',
            name: 'Hotel',
            component: Hotel,
            meta: {
                parentMenu: 'OrderList'
            },
        },


    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js